import { ContactSlugEnum as e } from "@systemeio/types";
//#region src/contacts/get-contact-field-title.ts
var t = {
	[e.Email]: "contact_slug.email",
	[e.FirstName]: "contact_slug.first_name",
	[e.Surname]: "contact_slug.last_name",
	[e.PhoneNumber]: "contact_slug.phone_number",
	[e.Country]: "contact_slug.country",
	[e.Neighborhood]: "contact_slug.neighborhood",
	[e.StreetAddress]: "contact_slug.street_address",
	[e.StreetNumber]: "contact_slug.street_number",
	[e.City]: "contact_slug.city",
	[e.Postcode]: "contact_slug.postal_code",
	[e.CompanyName]: "contact_slug.company_name",
	[e.TaxNumber]: "contact_slug.tax_number",
	[e.State]: "contact_slug.state_province"
}, n = (e, n) => n(t[e]), r = (t, r) => {
	let { slug: i, fieldName: a } = t;
	return Object.values(e).includes(i) ? n(i, r) : a;
};
//#endregion
export { r as getContactFieldTitle, n as getContactSlugName };
